<template>
    <v-dialog v-model="show" persistent max-width="80%" style="border-radius: 10px">
        <v-card>
            <v-card-title class="headline">
                <span style="color: #4a4a4a">{{$t('zip.resultDialog.title')}}</span>
            </v-card-title>
            <v-card-text>
                <div v-if="result && result.message" class="mb-4">
                    <strong>{{$t('system.messages.processedFile')}}: {{ result.processedFiles }}</strong>
                </div>
                
                <div v-if="result && result.messages && result.messages.length > 0">
                    <h3 class="mb-3">{{$t('zip.resultDialog.details')}}</h3>
                    <merus-data-table 
                        :headers="headersWithProperties" 
                        :items="processedMessages" 
                        dense 
                        class="elevation-7"
                        locale="pt" 
                        style="border-radius: 10px"
                        :loading-text="$t('system.messages.loading')"
                        @update:displayedItems="displayedItemsForExport = $event"
                    >
                        <template v-slot:toolbar>
                            <CadastroToolbar
                                :title="$t('zip.resultDialog.title')"
                                :token="token"
                                :items="displayedItemsForExport !== null ? displayedItemsForExport : processedMessages"
                                :csv-title="$t('zip.resultDialog.title')"
                                :csv-headers="headers"
                                :pdf-title="$t('zip.resultDialog.title')"
                                :pdf-headers="headers"
                                pdf-filename="zip-result"
                                hide-search
                            />
                        </template>
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>
                                    <span :class="{ 'error--text': item.isError }">
                                        {{ item.mensagem }}
                                    </span>
                                </td>
                            </tr>
                        </template>
                    </merus-data-table>
                </div>
            </v-card-text>
            <v-card-actions>
                <strong :style="{ color: '#4a4a4a' }">{{$t('system.messages.fileProcessedSuccess')}}!</strong>
                <v-spacer></v-spacer>
                <v-btn color="primary" class="white--text" @click="close">{{$t('button.close')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import CadastroToolbar from '../Toolbars/CadastroToolbar.vue';
import MerusDataTable from '../Tables/MerusDataTable.vue';

export default {
    name: "ResultDialogZIP",
    components: {
        CadastroToolbar,
        MerusDataTable,
    },
    props: {
        show: {
            type: Boolean,
            required: true
        },
        result: {
            type: Object,
            default() {
                return {
                    message: "",
                    messages: [],
                }
            }
        },
        token: {
            type: String,
            required: true
        },
    },
    data: () => ({
        displayedItemsForExport: null,
    }),
    computed: {
        headers() {
            return [
            { text: this.$t('tracking.message'), value: "mensagem" }];

        },
        processedMessages() {
            if (!this.result.messages) return [];
            
            return this.result.messages.map(msg => ({
                mensagem: msg,
                isError: msg.toLowerCase().includes(this.$t('relComunication.header.error')) || 
                         msg.toLowerCase().includes(this.$t('zip.resultDialog.notFound')) || 
                         msg.toLowerCase().includes(this.$t('zip.resultDialog.invalid'))
            }));
        },
        headersWithProperties() {
            return this.headers.map(header => ({
                ...header,
                filtrable: true,
                sortable: true
            }));
        }
    },
    methods: {
        close() {
            this.$emit('close');
        }
    }
}
</script>